import React from 'react';

import { ContextReducer } from '../../reducers/context';
import Message from '../Messages/Message';

export interface Props {
    context: ContextReducer;
    url?: string;
}

const Signing = ({ context, url }: Props): JSX.Element => {
    const exitReturnUrl = window.location.href;
    const cancelReturnUrl = `${window.location.origin}${context.config.data.landingPagePath}`;

    if (url) {
        return (
            <iframe
                className="signing__iframe"
                title="esignering-iframe"
                src={`${url}&deflecttarget=_top&exit=${exitReturnUrl}&cancel=${cancelReturnUrl}`}
            />
        );
    }

    return <Message title="Mangler signerings URL!" />;
};

export default Signing;
